export const RESET_VALUES_DIALOG_TITLE = 'Rensa formuläret?'
export const RESET_VALUES_DIALOG_BODY = 'Vill du rensa samtliga värden från formuläret?'
